import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";
import { logLibraryEvent } from "./libraryAnalytics";

/**
 * Repository callable aduan hak cipta (Sesi L6, pola sourceStore.js).
 * Tanpa tulis Firestore dari browser; seluruh tulis lewat Admin SDK.
 * Batas client-side mencerminkan skema server (10–2000 karakter pesan).
 */
export function validateReportInput({ sourceId, category, message, contactEmail }) {
  const errors = {};
  if (typeof sourceId !== "string" || sourceId.trim().length === 0) {
    errors.sourceId = "required";
  }
  if (!["copyright", "license", "other"].includes(category)) {
    errors.category = "required";
  }
  const text = typeof message === "string" ? message.trim() : "";
  if (text.length < 10) {
    errors.message = "too-short";
  } else if (text.length > 2000) {
    errors.message = "too-long";
  }
  const email = typeof contactEmail === "string" ? contactEmail.trim() : "";
  if (email.length > 0 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.contactEmail = "invalid";
  }
  return { errors, valid: Object.keys(errors).length === 0 };
}

export async function submitCopyrightReport({ sourceId, category, message, contactEmail }) {
  const { errors, valid } = validateReportInput({ sourceId, category, message, contactEmail });
  if (!valid) return { error: "invalid", errors };
  try {
    const fn = httpsCallable(functions, "reportSource");
    const payload = {
      sourceId: sourceId.trim(),
      category,
      message: message.trim(),
    };
    const email = typeof contactEmail === "string" ? contactEmail.trim() : "";
    if (email.length > 0) payload.contactEmail = email;
    const res = await fn(payload);
    if (res.data?.ok && res.data.reportId) {
      void logLibraryEvent("copyright_report_submitted", { category });
      return { reportId: res.data.reportId, sourceId: res.data.sourceId };
    }
    return { error: "write" };
  } catch (err) {
    if (err?.code === "functions/unauthenticated") return { error: "unauthenticated" };
    if (err?.code === "functions/not-found") return { error: "missing" };
    if (err?.code === "functions/invalid-argument") return { error: "invalid" };
    if (err?.code === "functions/resource-exhausted") return { error: "rate-limited" };
    return { error: "write" };
  }
}
